import { GoalType } from "@ctypes";

export type GoalTypeSelectionState = {
  education: boolean;
  home: boolean;
  longTerm: boolean;
  emergencyFund: boolean;
  highYieldSavings: boolean;
  vacation: boolean;
  trumpSidecar: boolean;
  custom: boolean;
};

export type GoalTypeSelectionAction = {
  type: GoalTypeSelectionType;
};

export enum GoalTypeSelectionType {
  Education = "education",
  Home = "home",
  LongTerm = "longTerm",
  EmergencyFund = "emergencyFund",
  HighYieldSavings = "highYieldSavings",
  Vacation = "vacation",
  TrumpSidecar = "trumpSidecar",
  Custom = "custom",
}

export type UseGoalTypeScreenFlowProps = {
  goalType: GoalType;
};
